export default __webpack_public_path__ + "static/media/Inter-ExtraLight.19c859e3.ttf";